import React, { useRef, useState } from "react";
import { Bot, sendMessage as sendBotMessage } from "./bot-loaders";
import { useModalHide } from "./components/Modal";
import { PatternFormat } from "react-number-format";
import { Loading } from "./components/Loading";
import { useNumberMask } from "datepicker";



function PhoneNumber({setTo, value}:{setTo:(a:string)=>void, value:string}){
    const ref = useRef();
    useNumberMask({mask: "phone", ref})

    return <input ref={ref}  className="form-control mb-2" placeholder="(34) 99999-9999" value={value} onChange={e => setTo(e.target.value)} />
}


export function BotMessageModal({bot}:{bot:Bot}){
    const [text, setText] = useState("");
    const [to, setTo] = useState("");
    const [doc, setDoc] = useState(null);
    const [loading, setLoading] = useState(false);
    const file = useRef<HTMLInputElement>();

    const hide = useModalHide();

    async function sendMessage(){
        if(to == "") return;
        if(text == "") return;
        await sendBotMessage(bot, {to, message: text, doc})
        setDoc(null);
        hide();
    }

    function pickFile(){
        file.current.click();
    }

    async function fileChoose(){
        function toBase64(file:File):Promise<string | any> {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = reject;
            });
        }

        setLoading(true);
        var data = await toBase64(file.current.files[0]);
        data = data.replace(/^.+base64,/, '');
        console.log(data);
        setDoc({name: file.current.files[0].name, data})
        setLoading(false);
    }

    return <>
        <PhoneNumber setTo={setTo} value={to} />
        <textarea className="form-control mb-3" value={text} onChange={e => setText(e.target.value)} />
        <input className="d-none" type="file" ref={file} onChange={fileChoose} />
        <div className="d-flex justify-content-between">
            {doc == null && !loading && <button style={{minHeight: '38px'}} className="btn btn-warning me-2" onClick={pickFile}><i className="fa fa-paperclip"></i></button>}
            {loading && <Loading label="Lendo arquivo..." />}
            {doc != null && <div className="text-muted me-2">
                <button style={{minHeight: '38px'}} className="btn btn-warning me-2" onClick={() => {setDoc(null); file.current.value = null}}><i className="fa fa-trash"></i></button>
                Doc: {doc.name} 
            </div>}
            <button className="btn btn-primary" onClick={sendMessage}>Enviar</button>
        </div>
    </>
    
}